import { Component } from "react";
import { FixedSizeList as List } from "react-window";
import { Dropdown } from "antd";
import styled from "styled-components";
import { renderTokenIndicator, getSelectedCategoriesAndOperators } from "./FilterBarUtils";
import { FilterBarCategory } from "./FilterBarCategory";
import { FilterItemRow } from "./FilterItemRowStyle";
import { TokenField } from "./TokenField";

function PivotList(props) {
    const clickPivot = (pivot, sOperator) => () => {
        props.addPivot(pivot, sOperator);
    };
    
    const createMainList = () => {
        const pivotList = Object.keys(props.allData).filter((k) => !props.readOnlyDimensions.has(k)).map((pivot) => {
            const alias = props.allData[pivot][0].pivot_alias;
            const alreadySelected = props.selectedCategories.some((c) => c.category === pivot);
            return { display: alias, pivot, alreadySelected };
        });
        const filteredList = pivotList.filter((p) => !p.alreadySelected).sort((a, b) => (a.display > b.display ? 1 : -1));
    
        const mainListRendererResults = (resultsList) => function({
            key, index, isScrolling, isVisible, style
        }) {
            return (
                <FilterItemRow key={key} style={style} className="pivot-list-row">
                    <div onClick={clickPivot(resultsList[index].pivot, "!=")}>
                        {renderTokenIndicator(["!="])}
                    </div>
                    <div onClick={clickPivot(resultsList[index].pivot, "=")}>
                        {renderTokenIndicator(["="])}
                    </div>
                    <div className="row-label" onClick={clickPivot(resultsList[index].pivot, "=")}>
                        <div className="item-value">{resultsList[index].display}</div>
                    </div>
                </FilterItemRow>
            );
        };
    
        return (
            <div className="menu-list">
                <List
                    className="pivot-list"
                    style={{ paddingBottom: "15px" }}
                    height={290}
                    itemCount={filteredList.length}
                    itemSize={26}
                    width={249}
                >
                    {mainListRendererResults(filteredList)}
                </List>
            </div>
        );
    };
    return (
        // TODO: deprecate overlay, refactor menu
        <Dropdown overlay={createMainList()} placement="bottomRight" trigger={["click"]} getPopupContainer={(trigger) => trigger}>
            <PivotMenu>
                <div className="add-category">Add a category</div>
            </PivotMenu>
        </Dropdown>
    );
}

export class FilterBarCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newCategory: {}
        };
    }
    
    addCategory = (pivot, operator) => {
        this.setState({ newCategory: { category: pivot, operators: [operator] } });
    };
    
    render() {
        if (this.props.allData) {
            const permQs = this.props.qualifiers.value.map((c) => c.category);
            const tempQs = this.props.tempQualifiers.value.map((c) => c.category);
            const allCategories = Array.from(new Set([...permQs, ...tempQs])).sort() || [];
            if (this.state.newCategory.category && !allCategories.includes(this.state.newCategory.category)) {
                allCategories.push(this.state.newCategory.category);
            }
            const selectedCategories = [...getSelectedCategoriesAndOperators(this.props.qualifiers), this.state.newCategory];
            
            const CategoryRows = allCategories.map((c) => {
                const data = this.props.allData[c];
                if (data) {
                    return (
                        <FilterBarCategory
                            key={`category_${c}`}
                            category={c}
                            selectedCategories={selectedCategories}
                            qualifiers={this.props.qualifiers}
                            getTokens={this.props.getTokens}
                            data={data}
                            filterItemClick={this.props.filterItemClick}
                            readOnlyDimensions={this.props.readOnlyDimensions.has(c)}
                            onUpdate={this.props.onUpdate}
                            clearCategory={this.props.clearCategory}
                        />
                    );
                }
                return null;
            });
    
            return (
                <div className="tokens">
                    <TokenField>
                        <div className="tokenfield categories form-control">
                            {CategoryRows}
                            <PivotList
                                allData={this.props.allData}
                                selectedCategories={selectedCategories}
                                addPivot={this.addCategory}
                                readOnlyDimensions={this.props.readOnlyDimensions}
                            />
                        </div>
                    </TokenField>
                </div>
            );
        }
        return null;
    }
}

const PivotMenu = styled.div`
   
    max-width: 300px;
    .add-category {
        color: ${(props) => props.theme.colors["blue-wcag-327"]};
        display: flex;
        padding: 8px 0px 8px 2px;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
            text-decoration: none;
        }
    }
    
    .menu-list {
        outline: none;
        width: 254px;
        min-height: 35px;
        padding: 5px 3px;
        opacity: 1.0;
        background: ${(props) => props.theme.colors["canvas-white"]};
        z-index: 999;
        border: 1px solid ${(props) => props.theme.colors["gray-soft"]};
        
        .pivot-list {
            height: 100%;
            max-width: 260px;
            padding-right: 10px;
            outline: none;
          
        }
    }
`;
